import BaseElement from './BaseElement';
import SupportWidget from '../Components/SupportWidget/SupportWidget';
class SupportWidgetElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = SupportWidget;
    }
}
export default SupportWidgetElement;
